document.addEventListener('DOMContentLoaded', () => {
  // Utility: Move submenu items under their parent
  const moveMenuItems = (parentSelector, childSelectors) => {
    const parentItem = document.querySelector(parentSelector);
    if (!parentItem) return;

    parentItem.classList.add('has-arrow');

    let subMenu = parentItem.querySelector('.extra-submenu');
    if (!subMenu) {
      subMenu = document.createElement('ul');
      subMenu.className = 'extra-submenu';
      parentItem.appendChild(subMenu);
    }

    childSelectors.forEach(sel => {
      const item = document.querySelector(sel);
      if (item) subMenu.appendChild(item);
    });
  };

  // Toast
  moveMenuItems('.navmenu-item.navmenu-id-toast', [
    '.navmenu-item.navmenu-id-go-2',
    '.navmenu-item.navmenu-id-go-3'
  ]);

  // Clover
  moveMenuItems('.navmenu-item.navmenu-id-clover', [
    '.navmenu-item.navmenu-id-go-3rd-gen',
    '.navmenu-item.navmenu-id-flex',
    '.navmenu-item.navmenu-id-flex-3',
    '.navmenu-item.navmenu-id-flex-4',
    '.navmenu-item.navmenu-id-flex-pocket'
  ]);

  // Square
  moveMenuItems('.navmenu-item.navmenu-id-square', [
    '.navmenu-item.navmenu-id-handheld',
    '.navmenu-item.navmenu-id-terminal'
  ]);

  // Images for all models (disabled: picture option removed)
  /*
  const modelImages = {
    // Square models
    'navmenu-id-handheld': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/PD05653_-_Handheld_Subnav.png?v=1753809253',
    'navmenu-id-terminal': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/PD05653_-_Terminal_Subnav.png?v=1753809253',
    // Clover models
    'navmenu-id-go-3rd-gen': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/clover_go_3rd_gen.png?v=1753813351',
    'navmenu-id-flex': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/flex_2.png?v=1753814640',
    'navmenu-id-flex-4': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/flex_4.png?v=1753812815',
    'navmenu-id-flex-pocket': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/clover_flex_pocket.png?v=1754078263',
    // Toast models
    'navmenu-id-go-2': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/toast_go_2.png?v=1753814426',
    'navmenu-id-go-3': 'https://cdn.shopify.com/s/files/1/0010/6633/6311/files/toast_go_3.png?v=1753814122',
  };

  Object.entries(modelImages).forEach(([id, src]) => {
    const li = document.querySelector('.' + id);
    if (li) {
      const link = li.querySelector('a');
      if (link) {
        // Clean the link completely, then build fresh
        const text = link.textContent.trim();
        link.innerHTML = ""; // Remove all children and whitespace
        const span = document.createElement('span');
        span.textContent = text;
        link.appendChild(span);
        // Picture option removed (no <img> appended)
        // const img = document.createElement('img');
        // img.src = src;
        // img.alt = text;
        // img.className = 'submenu-thumb';
        // link.appendChild(img);
      }
    }
  });
  */
});
